(function () {
  angular.module('binky.core.user.roles', [
    'binky.core.feature',
    'binky.core.lodash',
    'binky.core.src2-migration',
  ]);
})();
